import useDSApplicationMode from '../../hooks/useDSApplicationMode'
import useKiosk from '../../../wss/global/hooks/useKiosk/useKiosk'

export default function KioskModeListener() {
  const appMode = useDSApplicationMode()
  useKiosk({ listenForUndock: appMode === 'STATION' })
  return null
}
